Vue.component('accordion', {
    data: function () {
        return {
            activePanel: 0,
        }
    },
    computed: {
    },
    methods: {
        makeActive (itemIndex) {
            this.activePanel === itemIndex
                ? this.activePanel = null
                : this.activePanel = itemIndex
        },
    }
});